export default __webpack_public_path__ + "static/media/hoodie2-back.8d32b2ae.webp";